import React from 'react'
import { ReactComponent as PlaySVG } from "assets/player/play.svg";
import { ReactComponent as PauseSVG } from "assets/player/pause.svg";
import { Button } from '../Button';


const Play = ({ isPlaying, onClick }) => {

  return (
    <Button onClick={onClick}>
      {isPlaying
        ? <PauseSVG height={19} width={19} />
        : <PlaySVG height={19} width={19} />
      }
    </Button>
  )
}

export default Play